import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';


import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';


import MemberChange from '../../components/reports/memberschange';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function ReportsMemberChange() {

    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");
    const [clublist, setList] = useState("");
    
    const [value, setValue] = React.useState(new Date());
    const [selectedDate, handleDateChange] = useState(new Date());
    const handleChange = (newValue) => {
      setValue(newValue);
    };


    

    useEffect(() => {
      // console.log("LE CLUB est le : " + this.props.clubid)
      //setFormValue(clubid,this.props.clubid);
       //this.setState({clubid: this.props.clubid}); 
      
        setDateDebut(formatDate(Date()));
        setDateFin(formatDate(Date()));


       }, []);
       

   
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    }

        
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table} //
        return (
           
                 <div style={{  width: '90%', margin: '3%' }}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale='fr'>
                        
                    <DesktopDatePicker
                        label="Date début"
                        inputFormat="yyyy-MM-dd"
                        value={dateDebut}
                        onChange={(newValue)  => setDateDebut(formatDate(newValue))}
                        renderInput={(params) => <TextField {...params} />}
                        />
                            
                        <DesktopDatePicker
                        label="Date fin"
                        inputFormat="yyyy-MM-dd"
                        value={dateFin}
                        onChange={(newValue)  => setDateFin(formatDate(newValue))}
                        renderInput={(params) => <TextField {...params} />}
                        />
                                            
                    </LocalizationProvider>
                    
                     <MemberChange key="sdsadsasdasddsad" dateDebut={dateDebut} dateFin={dateFin} />
                    

                  </div>

            
        );
   
};

export default ReportsMemberChange;